import { Box, Divider, Typography, useTheme } from "@mui/material";
import styles from "../../Layout/Header/Header.module.css";

const DEFAULT_LOGO_URL = "/images/logo/zanda-logo.svg";

export interface ISubscriptionInvoicesHeaderProps {
    logoUrl?: string | null;
    name?: string | null;
}

export default function SubscriptionInvoicesHeader({ logoUrl, name }: ISubscriptionInvoicesHeaderProps) {
    const theme = useTheme();

    return (
        <Box component="header" sx={{ zIndex: theme.zIndex.appBar }} className={styles.header}>
            <Box className={styles.headerContent}>
                {logoUrl && logoUrl !== DEFAULT_LOGO_URL ? (
                    <Box data-test-id="subscription_header_logo">
                        <img
                            data-test-id="image_subscription_header_logo"
                            src={logoUrl}
                            alt={name ?? ""}
                            className={styles.image}
                        />
                    </Box>
                ) : (
                    <Typography
                        variant="heading4"
                        className={styles.headerTitle}
                        color={theme.palette.primary.main}
                        data-test-id="text_subscription_header_name"
                    >
                        {name}
                    </Typography>
                )}
            </Box>
            <Divider sx={{ width: "100%", borderBottomWidth: 2 }} />
        </Box>
    );
}
